import React,{Component} from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import {createMarkup} from './Factory'; 
import {UISref} from 'ui-router-react'; 

class NewsItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			animateClass : 'fadeOut'
		}	
		this.onChange = this.onChange.bind(this);
	}
	onChange(isVisible){
		if(isVisible) { 
			this.setState({ animateClass : 'fadeIn' });
		}
	}
	render(){
		const {title,slug='',date,excerpt,image_data,date_gmt} = this.props;
		const {label_mehr} = this.props.staticData;
		let {image:imgUrl,title:image_title,alt,image_tiny} = image_data;
		let divStyle = {
				backgroundImage: 'url(' + imgUrl + ')',
				backgroundSize: 'cover',
				maxWidth: '100%',
		}		
		return(
			<VisibilitySensor partialVisibility={true} offset={{top:500}} onChange={this.onChange} >
				<article className={`article-item col-md-4 ${this.state.animateClass}`}>
				   <UISref to="root.informationen.newsdetails" params={{item:slug}}>
					   <a>	
							<div className="fixed-ht-img ratio-news" >
                                <div title={image_title} className="img-wrapper" style={divStyle}>
                                </div>
							</div>
							<time aria-hidden="true" dateTime={date}>{date}</time>
							<time className="sr-only">{date_gmt}</time>
							<h1 className="md-txt" dangerouslySetInnerHTML={createMarkup(title.rendered)}></h1>
							<p className="sm-txt margin-top-20" dangerouslySetInnerHTML={createMarkup(excerpt.rendered)}></p>
							<span className="more-link">- {label_mehr}</span>
						</a>
					</UISref>
				</article>
			</VisibilitySensor>
		)
	}
}
export default NewsItem;




// WEBPACK FOOTER //
// ./src/components/NewsItem.js